import Header from './Header';
import { connect } from 'react-redux';
import { AppState } from '../../interfaces';

const mapStateToProps = (state: AppState) => ({
  rewards: state.rewardsReducer,
  user: state.preferencesReducer,
});

export default connect(mapStateToProps, null)(Header);
